import React from 'react'
import { string, bool, shape, func, instanceOf } from 'prop-types'
import BrandLoader from '../../BrandLoader/BrandLoader'
import commercialVehicle from '../../../assets/images/commercial-vehicle-details-large.png'
import commercialVehicleMobile from '../../../assets/images/commercial-vehicle-details-mobile.png'
import { useSelector } from 'react-redux'
import { selectLabels } from '../../../redux/configuration/selectors'

const CommercialVehicle = ({
  isLoading,
  handleVehicleSelection,
  vehicleOptions,
  lengthValidate,
  length,
  setLength
}) => {
  const labels = useSelector(selectLabels)
  const lengthInput = /^(\d{0,2})(\.\d*)?$/
  const isComplete = val => lengthValidate.test(val)
  const showHelperText = val => /^\d{1,2}\.\d{2}$/.test(val)
  const handleChange = event => {
    const rawData = event.target.value.replace(/[^0-9.]/g, '')
    if (lengthInput.test(rawData)) {
      setLength(rawData)

      handleVehicleSelection({
        ...vehicleOptions,
        defaultLength: isComplete(rawData) ? parseFloat(rawData) : null
      })
    }
  }

  const showHelper = length !== '' && !showHelperText(length)
  const helperClass = showHelper
    ? 'length-floating-helper'
    : 'length-floating-helper hidden'

  return isLoading ? (
    <BrandLoader />
  ) : (
    <div className="passenger-commercial-vehicles__initial-form">
      <div className="length-input-wrapper">
        <p className="length-label">{labels?.lengthUnderX}</p>
        <div className="length-input-inner">
          <input
            type="text"
            className="length-input"
            placeholder="Insert Length"
            value={length}
            onChange={handleChange}
          />
          <span className="length-unit">FT.</span>
          <span className={helperClass}>Insert Length</span>
        </div>
        <div className="length-img-frame">
          <img
            className="length-img length-img--mobile"
            src={commercialVehicleMobile}
            alt="Commercial Vehicle Dimensions"
          />
          <img
            className="length-img length-img--desktop"
            src={commercialVehicle}
            alt="Commercial Vehicle Dimensions"
          />
        </div>
      </div>
    </div>
  )
}

CommercialVehicle.propTypes = {
  isLoading: bool.isRequired,
  handleVehicleSelection: func.isRequired,
  vehicleOptions: shape({}).isRequired,
  lengthValidate: instanceOf(RegExp).isRequired,
  length: string.isRequired,
  setLength: func.isRequired
}

export default CommercialVehicle
